// extracted by mini-css-extract-plugin
export var pinContentNav = "pin-navigation-buttons-module--pinContentNav--7s8jk";
export var pinContentNavButton = "pin-navigation-buttons-module--pinContentNavButton--KfFVT";